import { GlobalDesignGroupAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';

export const borderGrouping: GlobalDesignGroupAction['grouping'] = {
  getGroupingStrategy: (editorPointers, getHost, componentsAPI) => {
    return () => {
      return groupByGroupDefinitions(
        editorPointers,
        'borderStyles',
        getHost,
        componentsAPI,
      );
    };
  },
};
